"use client";

import { use, useState } from "react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import {
  ChevronDown,
  ArrowLeft,
  Mail,
  Phone,
  Check,
  Icon,
  Badge,
} from "lucide-react";

interface ClientProps {
  service: any;
}

export default function ServiceDetailPageClient({ service }: ClientProps) {
  const [expandedFaq, setExpandedFaq] = useState<number | null>(0);
  return (
    <>
      {/* Hero Section */}
      <section className="px-4 py-12 sm:px-6 lg:px-8 bg-primary">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-10 lg:grid-cols-2 items-center">
            {/* Left: Text */}
            <div className="text-white space-y-5">
              <h1 className="text-4xl lg:text-5xl font-bold leading-tight text-balance">
                {service.name}
              </h1>
              <p className="text-lg text-white/85 leading-relaxed">
                {service.description}
              </p>
              {/* Tags */}

              <div className="flex flex-col sm:flex-row gap-3 pt-2">
                <Link href="#lien-he">
                <Button
                  size="lg"
                  className="bg-white text-primary hover:bg-gray-100 font-semibold flex items-center gap-2"
                >
                  <Mail className="h-4 w-4" />
                  Liên Hệ Tư Vấn
                </Button>
                </Link>
                <Link href={"tel:0886967375"}>
                  <Button
                    size="lg"
                    variant="outline"
                    className="bg-white/10 border-white/60 text-white hover:bg-white/10 font-semibold flex items-center gap-2"
                  >
                    <Phone className="h-4 w-4" />
                    Gọi Tư Vấn
                  </Button>
                </Link>
              </div>
            </div>

            {/* Right: Image + Price card */}
            <div className="space-y-4">
              {/* Image */}
              <div
                className="rounded-2xl overflow-hidden border border-white/20 shadow-2xl"
                style={{ height: "100%" }}
              >
                <img
                  src={service.image.large}
                  alt={service.name}
                  className="w-full h-full object-cover"
                />
              </div>

            </div>
          </div>
        </div>
      </section>

      <section className="px-4 py-14 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-12 lg:grid-cols-2">
            {/* Left: Detail Content (2/3) */}
            <div className="lg:col-span-2 space-y-12">
              {/* Rich Text Detail */}
              <div>
                <h2 className="text-2xl font-bold text-foreground mb-6">
                  Chi Tiết Dịch Vụ
                </h2>
                <div className="border border-slate-200 rounded-xl overflow-hidden">
                  <div
                    className="html-content prose prose-slate max-w-none p-6"
                    dangerouslySetInnerHTML={{ __html: service.content }}
                    style={{
                      lineHeight: "1.7",
                      color: "#334155",
                      minHeight: "200px",
                    }}
                  />
                </div>
              </div>

              {/* Features */}
              <div>
                <h2 className="text-2xl font-bold text-foreground mb-6">
                  Giá Trị Mang Lại
                </h2>
                <div className="grid gap-3 sm:grid-cols-2">
                  {(service?.features || []).map(
                    (feature: any, idx: number) => (
                      <div
                        key={`service.features.${idx}`}
                        className="flex items-start gap-3 p-3 rounded-xl"
                        style={{ backgroundColor: "#f8fafc" }}
                      >
                        <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center mt-0.5">
                          <Check className="h-3.5 w-3.5 text-primary" />
                        </div>
                        <span
                          className="text-sm leading-relaxed"
                          style={{ color: "#475569" }}
                        >
                          {feature}
                        </span>
                      </div>
                    ),
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
